export default __webpack_public_path__ + "static/media/loading-alt.4f42dc79.svg";